import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  header: [{
    title: 'benefits'
  }, {
    priceDetails: {
      price: '₹9.80',
      pricePostfix: '+ GST',
      strikedOldPricePostfix: '₹1500',
      savePrice: 'save ₹500'
    },
    titleWithDetails: 'Plan Name',
    infoTagModel: {
      infoTagText: 'selected plan',
      infoTagType: 'default'
    }
  }, {
    priceDetails: {
      price: '₹10.80',
      pricePostfix: '+ GST',
      strikedOldPricePostfix: '₹1500',
      savePrice: 'save ₹500'
    },
    titleWithDetails: 'Plan Name',
    infoTagModel: {
      infoTagText: 'recommended',
      infoTagType: 'new'
    }
  }],
  list: [[{
    subTitle: 'Validity'
  }, {
    subSection: '1-month',
    subSectionColor: '#D73737'
  }, {
    subSection: '2-month',
    isBoldSubsection: true
  }], [{
    subTitle: 'Speed',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    subSection: '40 Mbps',
    infoTagModel: {
      infoTagText: 'selected plan',
      infoTagType: 'default'
    }
  }, {
    subSection: '60 Mbps',
    isBoldSubsection: false,
    isSubSectionStrikeOut: true,
    infoTagModel: {
      infoTagText: 'selected plan',
      infoTagType: 'default'
    },
    subSectionCtaText: 'Click Me'
  }], [{
    subTitle: 'Hello Tunes',
    subTitleDescription: '1234567890',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    iconName: 'CancelFilledIcon',
    iconColorToken: '#D73737'
  }, {
    iconName: 'TickEnclosedFilledIcon',
    iconColorToken: '#18BDA9'
  }], [{
    subTitle: 'Disney Hotstar',
    subTitleDescription: '1234567890',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    iconName: 'CancelFilledIcon',
    iconColorToken: '#D73737'
  }, {
    iconName: 'TickEnclosedFilledIcon',
    iconColorToken: '#18BDA9'
  }], [{
    subTitle: 'Prime',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    iconName: 'CancelFilledIcon',
    iconColorToken: '#D73737'
  }, {
    iconName: 'TickEnclosedFilledIcon',
    iconColorToken: '#18BDA9'
  }], [{
    subTitle: 'Zee 5',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    iconName: 'CancelFilledIcon',
    iconColorToken: '#D73737'
  }, {
    iconName: 'TickEnclosedFilledIcon',
    iconColorToken: '#18BDA9'
  }], [{
    subTitle: 'Amazon Prime Video',
    benefitIconName: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
  }, {
    iconName: 'CancelFilledIcon',
    iconColorToken: '#D73737'
  }, {
    iconName: 'TickEnclosedFilledIcon',
    iconColorToken: '#18BDA9'
  }]]
}, getTestId('UpsellNudgetWidgetContainer'));